import comp from "./SubjectViewOnly";
export default comp;
